import React, { useState } from "react";

type Props = {
  text?: string;
  description?: string | React.ReactElement;
  step?: string;
};

export default function SignUpStepExplanation({
  text,
  description,
  step = "1",
}: Readonly<Props>) {
  const [showDescription, setShowDescription] = useState(false);

  const handleOnClick = () => {
    setShowDescription(!showDescription);
  };

  return (
    <div
      id={`step-${step}-explanation`}
      className="step-explanation-item"
      data-testid={`step-${step}-explanation`}
    >
      <div
        id="explanation-text"
        className="step-explanation-text-flex-container"
      >
        <span className="step-explanation-bullet">{step}</span>
        <p className="step-explanation-text">{text}</p>
        {description ? (
          <button
            id={`step-${step}-more`}
            type="button"
            className="btn-primary btn-link"
            onClick={() => handleOnClick()}
          >
            <span
              className={
                showDescription
                  ? "icon icon2-eh-arrow-up"
                  : "icon icon2-eh-arrow-down"
              }
            />
          </button>
        ) : null}
      </div>
      {showDescription ? (
        <div className="step-explanation-description-flex-container space-after">
          <span className="step-explanation-place-holder" />
          {description}
        </div>
      ) : null}
    </div>
  );
}
